import { render } from "./SmartBanking.vue?vue&type=template&id=16bda219&ts=true"
import script from "./SmartBanking.vue?vue&type=script&lang=ts"
export * from "./SmartBanking.vue?vue&type=script&lang=ts"

import "./SmartBanking.vue?vue&type=style&index=0&id=16bda219&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__